import { h } from '@stencil/core';
import type { ConversationalSearchMessagesDynamicMediator } from './dynamic-mediator';

export type RenderingList = {
  type: string;
  component: string | Function;
  componentType: 'F' | 'W';
  props: string[];
  checkCallback?: () => boolean;
};

// Dynamic loader for WebComponents and FunctionalComponents
// 1. Check if element type is equal to the type specified in element
// 2. If not, check if the element has a checkCallback function and execute it
// 3. If not, load the fallback component
export const getComponentToRender = async (
  context: ConversationalSearchMessagesDynamicMediator,
  elements: RenderingList[],
  type: string,
  fallbackType: string
) => {
    let Component;
    const selectedElement =
      elements.find(element => element.type === type) ||
      elements.find(element => element?.checkCallback && element.checkCallback()) ||
      elements.find(element => element.type === fallbackType);

    const isFunctionalComponent = selectedElement.componentType === 'F';
    Component = selectedElement.component;

    const props = selectedElement.props.reduce((acc, prop) => {
        acc[prop] = context[prop];
        return acc;
    }, {} as Record<string, unknown>);

    return isFunctionalComponent ?
      h(Component, props) :
      <Component {...props} />;
};